import { render, staticRenderFns } from "./topbar-default.vue?vue&type=template&id=84f47294"
import script from "./topbar-default.vue?vue&type=script&lang=js"
export * from "./topbar-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports